import { useMemo, type FC } from 'react'

import { AnimateBox } from '../../components/animate-box'
import { Wrap } from '../../components/wap'
import { STATIC_OBS_URL } from '../../consts'
import { dateFormat } from '../../tools/date'
const bannerUrl = `${STATIC_OBS_URL}/website/home/news/banner.png?2`

const menus = [
  {
    name: '公司动态',
    props: {
      title: '公司动态',
      href: '/news/company'
    }
  }
  // {
  //   name: '行业资讯',
  //   props: {
  //     title: '行业资讯',
  //     href: '/news/industry'
  //   }
  // }
]

export interface NewsListProps {
  data: {
    _id: string
    title: string
    thumbnail: string
    description: string
    url: string
    publishTime: string
    type: number
  }[]
  page: {
    total: number
    pageSize: number
    pageIndex: number
  }
}

const pagination = (params: NewsListProps['page']) => {
  const result: { type: 'num' | 'cur' | 'pre' | 'next' | 'first' | 'last'; value: number }[] = []
  const leftFloat = 4
  const rightFloat = 4
  const { pageSize, pageIndex, total } = params
  const totalPage = Math.ceil(total / pageSize)
  for (let i = pageIndex - leftFloat; i <= pageIndex + rightFloat; i++) {
    if (i >= 1 && i <= totalPage) {
      const type = i === pageIndex ? 'cur' : 'num'
      result.push({ type, value: i })
    }
  }
  return result
}

export const NewsList: FC<NewsListProps> = props => {
  const { data = [], page } = props

  const active = useMemo(() => {
    const { type } = data?.at(0) || {}
    return type === 2 ? 1 : 0
  }, [data])

  return (
    <Wrap className='news-list'>
      <div
        className='public-banner-box'
        style={{
          backgroundImage: `url(${bannerUrl})`,
          backgroundSize: 'cover'
        }}
      >
        <AnimateBox tagName='h2'>新闻资讯</AnimateBox>
        <AnimateBox animateDelay={0.5} tagName='p'>
          及时掌握最新科技动态，探索行业前沿趋势，助力企业创新发展
        </AnimateBox>
      </div>

      <div className='public-tab-box white'>
        <div className='inner-wrap'>
          {menus.map(({ name, props }, index) => (
            <AnimateBox animateDelay={0.5 + 0.3 * index} key={name} tagName='li'>
              <a {...props} className={active === index ? 'active' : ''}>
                {name}
              </a>
            </AnimateBox>
          ))}
        </div>
      </div>

      <main className='main'>
        <div className='content'>
          {data.map(({ _id, title, thumbnail, description, url, publishTime }) => (
            <AnimateBox key={_id}>
              <div className='list hover-scale' key={_id}>
                <div className='left'>
                  <p className='date'>{dateFormat(publishTime, 'yyyy年MM月dd日')} </p>
                  <div className='title'>
                    <h1>{title}</h1>
                  </div>
                  <p className='desc'>{description}</p>

                  <a
                    className='look-more-blue btn'
                    href={url ? url : `/news/${_id}`}
                    rel='noreferrer'
                    target='_blank'
                    title={title}
                  >
                    阅读全文
                  </a>
                </div>
                <div
                  className='right'
                  style={{
                    backgroundImage: `url(${STATIC_OBS_URL}/website/${thumbnail})`
                  }}
                />
              </div>
            </AnimateBox>
          ))}
        </div>

        <div className='pagination-box'>
          {pagination(page).map(item => {
            if (item.type === 'cur') {
              return (
                <span className='item active' key={item.value}>
                  {item.value}
                </span>
              )
            }
            return (
              <a className='item' href={`?page=${item.value}`} key={item.value}>
                {item.value}
              </a>
            )
          })}
        </div>
      </main>
    </Wrap>
  )
}
